import React from "react"
import QuoteRequestModalLibrary  from '../components/quote-request-modal-library'

export default function ModalReviews({pro})
{            
    return (
        <QuoteRequestModalLibrary
            showButton={false}
            showButtonForProfile={true}
            startVisible={false}
            proid={pro.profile.id}
            ondeffCode= 'reviewForm'
            pro_name= {pro.profile.name} />
    ) 
}